import { StrictLocalizeFunction } from "@faire/web/common/localization";

export const INBOUND_BRAND_CATEGORY_OPTIONS = (
  strictLocalize: StrictLocalizeFunction
) => [
  {
    label: strictLocalize({
      id: "+XrhWI",
      defaultMessage: "Home Decor",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "Home Decor",
    popularity: 0,
    subCategories: [
      {
        label: strictLocalize({
          id: "bJ+hBM",
          defaultMessage: "Bath",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bath",
      },
      {
        label: strictLocalize({
          id: "QpFTMk",
          defaultMessage: "Bedding",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bedding",
      },
      {
        label: strictLocalize({
          id: "6LaNB4",
          defaultMessage: "Candles & Holders",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Candles & Holders",
      },
      {
        label: strictLocalize({
          id: "JIh7K2",
          defaultMessage: "Garden & Outdoor",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Garden & Outdoor",
      },
      {
        label: strictLocalize({
          id: "HNtU8B",
          defaultMessage: "Home Accents & Fragrances",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Home Accents & Fragrances",
      },
      {
        label: strictLocalize({
          id: "18mYMC",
          defaultMessage: "Household Supplies & DIY",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Household Supplies & DIY",
      },
      {
        label: strictLocalize({
          id: "UV8jNJ",
          defaultMessage: "Kitchen & Tabletop",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Kitchen & Tabletop",
      },
      {
        label: strictLocalize({
          id: "OB0U2M",
          defaultMessage: "Storage & Organization",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Storage & Organization",
      },
      {
        label: strictLocalize({
          id: "FUeXgR",
          defaultMessage: "Throw Pillows & Blankets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Throw Pillows & Blankets",
      },
      {
        label: strictLocalize({
          id: "aB2whS",
          defaultMessage: "Wall Decor",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Wall Decor",
      },
    ],
  },
  {
    label: strictLocalize({
      id: "9ks2Sf",
      defaultMessage: "Beauty & Wellness",
    }),
    value: "Beauty & Wellness",
    popularity: 2,
    subCategories: [
      {
        label: strictLocalize({
          id: "exkF8h",
          defaultMessage: "Bath & Body",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bath & Body",
      },
      {
        label: strictLocalize({
          id: "aqlbTQ",
          defaultMessage: "Fitness & Yoga",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Fitness & Yoga",
      },
      {
        label: strictLocalize({
          id: "daxsVh",
          defaultMessage: "Fragrance",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Fragrance",
      },
      {
        label: strictLocalize({
          id: "JYm7Qp",
          defaultMessage: "Haircare",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Haircare",
      },
      {
        label: strictLocalize({
          id: "oZwpev",
          defaultMessage: "Health & Wellness",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Health & Wellness",
      },
      {
        label: strictLocalize({
          id: "Yf9m/Y",
          defaultMessage: "Makeup",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Makeup",
      },
      {
        label: strictLocalize({
          id: "ZFYgkh",
          defaultMessage: "Men’s grooming",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Men’s grooming",
      },
      {
        label: strictLocalize({
          id: "iyc8Hf",
          defaultMessage: "Personal care",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Personal care",
      },
      {
        label: strictLocalize({
          id: "sr8MCw",
          defaultMessage: "Skincare",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Skincare",
      },
      {
        label: strictLocalize({
          id: "PNOW3H",
          defaultMessage: "Spa & Spiritual",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Spa & Spiritual",
      },
    ],
  },
  {
    label: strictLocalize({
      id: "cn2GtC",
      defaultMessage: "CBD/THC",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "CBD/THC",
    subCategories: [],
    popularity: 17,
  },
  {
    label: strictLocalize({ id: "39T2UN", defaultMessage: "Food & Drink" }),
    value: "Food & Drink",
    popularity: 4,
    subCategories: [
      {
        label: strictLocalize({
          id: "5+bXB5",
          defaultMessage: "Baking and Confections",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Baking",
      },
      {
        label: strictLocalize({
          id: "6+7pyY",
          defaultMessage: "Beverages",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Beverages",
      },
      {
        label: strictLocalize({
          id: "GtkVdm",
          defaultMessage: "Cereal, Grains, & Pastas",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Cereal, Grains, & Pastas",
      },
      {
        label: strictLocalize({
          id: "D1OVKd",
          defaultMessage: "Coffee & Tea",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Coffee & Tea",
      },
      {
        label: strictLocalize({
          id: "I9Kz2a",
          defaultMessage: "Condiments & Sauces",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Condiments & Sauces",
      },
      {
        label: strictLocalize({
          id: "GZ7Nre",
          defaultMessage: "Dairy & Meats",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Dairy & Meats",
      },
      {
        label: strictLocalize({
          id: "1eGTPO",
          defaultMessage: "Food Baskets & Kits",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Food Baskets & Kits",
      },
      {
        label: strictLocalize({
          id: "9edsq6",
          defaultMessage: "Jams & Spreads",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Jams & Spreads",
      },
      {
        label: strictLocalize({
          id: "O5mMJr",
          defaultMessage: "Snacks",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Snacks",
      },
      {
        label: strictLocalize({
          id: "be0mGr",
          defaultMessage: "Wine, Beer & Spirits",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Wine, Beer & Spirits",
      },
    ],
  },
  {
    label: strictLocalize({ id: "xdnkuw", defaultMessage: "Jewelry" }),
    value: "Jewelry",
    popularity: 11,
    subCategories: [
      {
        label: strictLocalize({
          id: "U6KHs5",
          defaultMessage: "Body & Jewelry",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Body & Jewelry",
      },
      {
        label: strictLocalize({
          id: "hzx3ku",
          defaultMessage: "Bracelets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bracelets",
      },
      {
        label: strictLocalize({
          id: "9k+4dn",
          defaultMessage: "Brooches",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Brooches",
      },
      {
        label: strictLocalize({
          id: "/LGp+a",
          defaultMessage: "Cufflinks & Tie Clips",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Cufflinks & Tie Clips",
      },
      {
        label: strictLocalize({
          id: "ElhTsX",
          defaultMessage: "Earrings",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Earrings",
      },
      {
        label: strictLocalize({
          id: "gdsYKT",
          defaultMessage: "Jewelry Sets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Jewelry Sets",
      },
      {
        label: strictLocalize({
          id: "jCoft8",
          defaultMessage: "Jewelry Storage & Care",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Jewelry Storage & Care",
      },
      {
        label: strictLocalize({
          id: "txBGP/",
          defaultMessage: "Necklaces",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Necklaces",
      },
      {
        label: strictLocalize({
          id: "Zw164r",
          defaultMessage: "Rings",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Rings",
      },
      {
        label: strictLocalize({
          id: "wQRrWV",
          defaultMessage: "Watches",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Watches",
      },
    ],
  },
  {
    label: strictLocalize({
      id: "O3UV9O",
      defaultMessage: "Kids & Baby - Apparel",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "Kids & Baby - Apparel",
    popularity: 9,
    subCategories: [],
  },
  {
    label: strictLocalize({
      id: "D8mc4E",
      defaultMessage: "Kids & Baby - Non-Apparel",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "Kids & Baby - Non-Apparel",
    popularity: 10,
    subCategories: [
      {
        label: strictLocalize({
          id: "WFdWyH",
          defaultMessage: "Bath & Safety",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Bath & Safety",
      },
      {
        label: strictLocalize({
          id: "cRP5NO",
          defaultMessage: "Gear & Essentials",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Gear & Essentials",
      },
      {
        label: strictLocalize({
          id: "Tk1GxC",
          defaultMessage: "Maternity",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Maternity",
      },
      {
        label: strictLocalize({
          id: "e3PBEI",
          defaultMessage: "Nursery & Decor",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Nursery & Decor",
      },
      {
        label: strictLocalize({
          id: "Gi+dzJ",
          defaultMessage: "Paper & Novelty",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Paper & Novelty",
      },
      {
        label: strictLocalize({
          id: "RMVbSZ",
          defaultMessage: "Toys & Learning",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Toys & Learning",
      },
    ],
  },
  {
    label: strictLocalize({
      id: "DsFXpW",
      defaultMessage: "Men's Accessories",
    }),
    value: "Men's Accessories",
    popularity: 8,
    subCategories: [],
  },
  {
    label: strictLocalize({ id: "AQG/Qo", defaultMessage: "Men's Apparel" }),
    value: "Men's Apparel",
    popularity: 7,
    subCategories: [],
  },
  {
    label: strictLocalize({
      id: "GJp425",
      defaultMessage: "Raw Materials",
      description: { text: "Category of products that a brand sells" },
    }),
    value: "Raw Materials",
    popularity: 18,
    subCategories: [],
  },

  {
    label: strictLocalize({ id: "zfh1hM", defaultMessage: "Paper & Novelty" }),
    value: "Paper & Novelty",
    popularity: 13,
    subCategories: [
      {
        label: strictLocalize({
          id: "2qEcPL",
          defaultMessage: "Books",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Books",
      },
      {
        label: strictLocalize({
          id: "mBG6QD",
          defaultMessage: "Crafts & Hobbies",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Crafts & Hobbies",
      },
      {
        label: strictLocalize({
          id: "rqNqwF",
          defaultMessage: "Games & Puzzles",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Games & Puzzles",
      },
      {
        label: strictLocalize({
          id: "W2Tx9M",
          defaultMessage: "Gift wrapping",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Gift wrapping",
      },
      {
        label: strictLocalize({
          id: "5QLCNl",
          defaultMessage: "Greeting cards",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Greeting cards",
      },
      {
        label: strictLocalize({
          id: "n/raiP",
          defaultMessage: "Party Supplies",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Party Supplies",
      },
      {
        label: strictLocalize({
          id: "UibxLW",
          defaultMessage: "Stationary & writing",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Stationary & writing",
      },
      {
        label: strictLocalize({
          id: "Ok6vKb",
          defaultMessage: "Stickers, Pins, Magnets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Stickers, Pins, Magnets",
      },
    ],
  },
  {
    label: strictLocalize({ id: "JH2EfS", defaultMessage: "Pets" }),
    value: "Pets",
    popularity: 14,
    subCategories: [
      {
        label: strictLocalize({
          id: "i+XZGK",
          defaultMessage: "Cats",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Cats",
      },
      {
        label: strictLocalize({
          id: "ncBTF0",
          defaultMessage: "Dogs",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Dogs",
      },
      {
        label: strictLocalize({
          id: "khkzZJ",
          defaultMessage: "Other pets",
          description: { text: "Category of products that a brand sells" },
        }),
        value: "Other pets",
      },
    ],
  },
  {
    label: strictLocalize({
      id: "JCPxDM",
      defaultMessage: "Women's Accessories",
    }),
    value: "Women's Accessories",
    popularity: 6,
    subCategories: [],
  },
  {
    label: strictLocalize({ id: "DTysey", defaultMessage: "Women's Apparel" }),
    value: "Women's Apparel",
    popularity: 5,
    subCategories: [],
  },
  {
    label: strictLocalize({ id: "/VnDMl", defaultMessage: "Other" }),
    value: "Other",
    popularity: 19,
    subCategories: [],
  },
];
